import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { MultiSelect } from './inputs/MultiSelect';

export const NeighborhoodsFilter = ({
  setFiltersAndSort,
  filtersAndSort,
  neighborhoods
}) => {
  const { neighborhoodsObj } = useSelector(state => state.props);

  const onChange = selected => {
    setFiltersAndSort({
      ...filtersAndSort,
      neighborhoods: selected.map(s => s.value)
    });
  };

  const options = neighborhoods.map(n => ({
    value: n,
    label: neighborhoodsObj[n]
  }));

  const value = filtersAndSort.neighborhoods.map(n => ({
    value: n,
    label: neighborhoodsObj[n]
  }));

  return (
    <Form.Group>
      <Form.Label>Barrios</Form.Label>

      <MultiSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder="Barrios"
      />
    </Form.Group>
  );
};
NeighborhoodsFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  neighborhoods: PropTypes.array.isRequired
};
